import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import LocaleContext from './locale-context';
import en from './en-US';
import zh from './zh-CN';
import id from './id-ID';
import vi from './vi-VN';
import th from './th-TH';
import zhTW from './zh-TW';
import my from './ms-MY';
import antdId from 'antd/es/locale/id_ID';
import antdEn from 'antd/es/locale/en_US';
import antdZh from 'antd/es/locale/zh_CN';
import antdVi from 'antd/es/locale/vi_VN';
import antdTH from 'antd/es/locale/th_TH';
import antdZhTw from 'antd/es/locale/zh_TW';
import antdMY from 'antd/es/locale/ms_MY';
import antdDefault from 'antd/es/locale/default';
import { staticLang } from './format-message';
export var locales = {
  'en-US': en,
  'id-ID': id,
  'zh-CN': zh,
  'vi-VN': vi,
  'th-TH': th,
  'zh-TW': zhTW,
  'ms-MY': my
};
var antdLocale = {
  'en-US': _objectSpread(_objectSpread({}, antdDefault), antdEn),
  'id-ID': _objectSpread(_objectSpread({}, antdDefault), antdId),
  'zh-CN': _objectSpread(_objectSpread({}, antdDefault), antdZh),
  'vi-VN': _objectSpread(_objectSpread({}, antdDefault), antdVi),
  'th-TH': _objectSpread(_objectSpread({}, antdDefault), antdTH),
  'zh-TW': _objectSpread(_objectSpread({}, antdDefault), antdZhTw),
  'ms-MY': _objectSpread(_objectSpread({}, antdDefault), antdMY)
};

var LocaleProvider = function LocaleProvider(_ref) {
  var children = _ref.children,
      currentLang = _ref.currentLang;
  var locale = locales[currentLang] || en;
  useEffect(function () {
    staticLang.current = currentLang;
  }, [currentLang]);

  var formatMessage = function formatMessage(_ref2) {
    var id = _ref2.id,
        values = _ref2.values;

    if (!values || !Object.keys(values).length) {
      return locale[id] || id;
    }

    return (locale[id] || id).replaceAll(/\{(.+?)\}/g, function (_, name) {
      return values[name];
    });
  };

  return _jsx(LocaleContext.Provider, {
    value: {
      formatMessage: formatMessage,
      currentLang: currentLang
    },
    children: _jsx(_ConfigProvider, {
      locale: antdLocale[currentLang] || antdDefault,
      children: children
    })
  });
};

export default LocaleProvider;